/* eslint-disable */
import './modules/global';
import './modules/poll';




// WEBPACK FOOTER //
// ./scripts/main.js